// extracted by mini-css-extract-plugin
export default {"header":"r4QTbuhk","label":"cTemaPXJ","active":"fGThVmTA","icon-up":"x7rDgdGN","iconUp":"x7rDgdGN","icon-down":"rQcQYfRM","iconDown":"rQcQYfRM"};